import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

export let toast = null; // export global que será utilizado por api.js

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toastState, setToastState] = useState({ show: false, message: '', variant: 'danger' });
  const timeoutRef = useRef(null);

  const showToast = (variant, message, duration = 3000) => {
    setToastState({ show: true, variant, message });

    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      setToastState({ show: false });
    }, duration);
  };

  // Esto lo hace disponible en api.js
  useEffect(() => {
    toast = { showToast };
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastState.variant}
          onClose={() => setToastState({ ...toastState, show: false })}
          show={toastState.show}
          delay={null} // manejamos el tiempo manualmente
          autohide={false}
        >
          <Toast.Body className="text-white">{toastState.message}</Toast.Body>
        </Toast>
      </ToastContainer>
    </ToastContext.Provider>
  );
};
